module.exports = __webpack_public_path__ + "files/b0b27c154c6bcece35d9a2e5a6d8520b.png";